import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import {
  IStackedBarChartConfig
} from "../../../../components/charts/types";
import { getGenericChartConfig } from "./utils";
import StackedBarChart from "../../../../components/charts/stackedBarChart";

const StackedBarChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, showAccumulated, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<IStackedBarChartConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series, xAxis, yAxes ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      setChartConfig( {
        height: parentSize.height - 20,
        series,
        xAxis,
        yAxis: yAxes[0],
        showLegend: true,
        showValue: false,
        accumulate: true
      });

    }
  }, [ cell, data, parentSize, palette, updatePalette, node, schemas ]);

  return (
    <div className="display-grid" style={{ ...parentSize }}>
      { chartConfig && <StackedBarChart barChartConfig={chartConfig} showAccumulated={showAccumulated} /> }
    </div>
  );
};

export default StackedBarChartWrapper;
